import { render, staticRenderFns } from "./TopOfMind.vue?vue&type=template&id=f861c6c8&"
import script from "./TopOfMind.vue?vue&type=script&lang=js&"
export * from "./TopOfMind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports